import { Button, Result } from "antd";
import { useNavigate } from "react-router";
import { ArrowLeftOutlined, HomeOutlined } from "@ant-design/icons";

const NotFoundPublic = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1); // Go back to previous page
  };

  const handleGoHome = () => {
    navigate("/"); // Navigate to public home page
  };

  return (
    <div className="min-h-screen flex justify-center items-center bg-slate-50">
      <div className="w-full max-w-lg px-4">
        <Result
          status="404"
          title={
            <span className="text-3xl font-bold text-gray-800">
              Halaman Tidak Ditemukan
            </span>
          }
          subTitle={
            <div className="text-gray-500 mt-2">
              Maaf, halaman yang Anda cari tidak tersedia atau telah
              dipindahkan.
            </div>
          }
          extra={
            <div className="flex flex-col sm:flex-row gap-4 justify-center mt-6">
              <Button
                type="primary"
                icon={<ArrowLeftOutlined />}
                onClick={handleGoBack}
                className="bg-blue-500 hover:bg-blue-600 border-blue-500"
                size="large"
              >
                Kembali
              </Button>
              <Button
                icon={<HomeOutlined />}
                onClick={handleGoHome}
                size="large"
              >
                Halaman Utama
              </Button>
            </div>
          }
        />

        <div className="mt-10 border-t pt-6 text-center text-gray-500 text-sm">
          <p>
            Jika Anda merasa ini adalah kesalahan, silakan hubungi dukungan
            kami.
          </p>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPublic;
